import axios from "axios";
import axiosInstance, { getBaseDomainURL } from "./axios.auth.config";
const baseURL = process.env.REACT_APP_BASE_URL;

export function verifyToken(payload) {
  return axios
    .post(`${baseURL}/accounts/auth/employees/invitations/check/`, payload)
    .then(({ data }) => data);
}

export function signup(payload) {
  return axios
    .post(`${baseURL}/accounts/auth/employees/signup/`, payload)
    .then(({ data }) => data);
}

export function login(payload) {
  return axios
    .post(`${baseURL}/accounts/auth/employees/login/`, payload)
    .then(({ data }) => data);
}

export function resetPassword(payload) {
  return axios
    .post(`${baseURL}/accounts/auth/password/reset/`, payload)
    .then(({ data }) => data);
}

export function confirmEmail(payload) {
  return axios
    .post(`${baseURL}/accounts/auth/password/reset/confirm`, payload)
    .then(({ data }) => data);
}

export function signUpExistingUser(payload) {
  return axios
    .post(`${baseURL}/accounts/auth/employees/invitations/accept/`, payload)
    .then(({ data }) => data);
}

export function getNavRestrictions() {
  return axiosInstance.get("/app_permissions/").then((res) => res.data);
}
export function getNavMenu(id) {
  return axiosInstance.get(`${getBaseDomainURL()}/employees/${id}/myedge-menu`).then((res) => res.data);
}
